/* eslint-disable prettier/prettier */
import { Menu as MenuCore, Sider } from '@greenglobal/greencore.fe.common'
import { head, isArray, isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import Icon from '@/components/Icon'
import { menuData } from '@/constants/menu'
import { checkPermission, flattenData } from '@/utils/Utils'
import styles from './styles.module.scss'
import { useSelector } from 'react-redux'
import { selectPermissions } from '@/reducers/authentication'

type MenuItem = Required<any>['items'][number]

const getItem = (label: React.ReactNode, key: React.Key, icon?: React.ReactNode, children?: MenuItem[]): MenuItem => {
  return {
    key,
    icon,
    children,
    label
  } as MenuItem
}

type itemMenu = {
  title: string
  key: React.Key
  icon?: React.ReactNode
  children?: itemMenu[]
  permissions?: string[]
  path?: string
}

type IMenu = {
  isCollapsed: boolean
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>
}

export const Menu = (props: IMenu) => {
  const { isCollapsed, setIsCollapsed } = props
  const { pathname } = useLocation()
  const [selectedKey, setSelectedKey] = useState(null)
  const [openKeys, setOpenKeys] = useState<string[]>([])

  const permissions = useSelector(selectPermissions)

  // Xử lý lấy OpenKeys menu
  const getOpenKeys = (selectedKey: string | null) => {
    if (!isArray(menuData)) {
      return []
    }

    let newOpenedKey: string[] = []

    menuData.forEach((item) => {
      if (isArray(item?.children)) {
        if (item?.children.find((child) => child.key === selectedKey)) {
          newOpenedKey.push(item?.key as string)
        }
      }
    })

    setOpenKeys(newOpenedKey) // Cập nhật openKeys đúng cách
  }

  useEffect(() => {
    const valuePath = pathname.split('/')
    const findMenu = flattenData(menuData)?.find((item: any) => {
      const indexUrl = item?.path?.findIndex((itemFind: any) => itemFind.includes(valuePath[1]))
      return indexUrl >= 0
    })

    if (findMenu) {
      setSelectedKey(findMenu.key)
      if (!isCollapsed) {
        getOpenKeys(findMenu.key)
      }
    }
  }, [pathname, isCollapsed])

  useEffect(() => {
    if (isCollapsed) {
      setOpenKeys([])
    } else if (selectedKey) {
      getOpenKeys(selectedKey)
    }
  }, [isCollapsed])

  const renderMenu = (menuData: itemMenu[]): itemMenu[] | undefined => {
    if (!isEmpty(menuData)) {
      return menuData.reduce((arr: any, item: any) => {
        if (checkPermission(item.permissions, permissions)) {
          const title = item?.label

          return [
            ...arr,
            getItem(
              item.children ? (
                title
              ) : (
                <Link className={styles.titlePath} to={head(item?.path) || '/'}>
                  {title}
                </Link>
              ),
              item?.key,
              <Icon icon={item.icon} className='nav-icon' />,
              renderMenu(item?.children)
            )
          ]
        } else {
          return arr
        }
      }, [])
    }

    return undefined
  }

  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsCollapsed(true)
    }
  }, [])

  return (
    <Sider
      collapsible
      collapsed={isCollapsed}
      width={window.innerWidth < 768 ? '100%' : 256}
      style={{ transition: 'all 0.2s ease' }}
      collapsedWidth={60}
      onCollapse={(value) => setIsCollapsed(value)}
      className={styles.sider}
    >
      <div className={styles.menu}>
        <MenuCore
          selectedKeys={selectedKey || undefined}
          mode='inline'
          items={renderMenu(menuData as any)}
          openKeys={openKeys}
          onOpenChange={(openKeys: string[]) => setOpenKeys(openKeys)}
        />
      </div>
    </Sider>
  )
}
